const initialBucketStore = {
}

export default initialBucketStore
